import { render, staticRenderFns } from "./FormClient.vue?vue&type=template&id=6164e5de&scoped=true&"
import script from "./FormClient.vue?vue&type=script&lang=js&"
export * from "./FormClient.vue?vue&type=script&lang=js&"
import style0 from "./FormClient.vue?vue&type=style&index=0&id=6164e5de&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6164e5de",
  null
  
)

export default component.exports